import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import './styles/global.css';
import './styles/components.css';

// Import pages
import LandingPage from './pages/LandingPage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import SignupPage from './pages/SignupPage';
import SignupSuccessPage from './pages/SignupSuccessPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PublicReportPage from './pages/PublicReportPage';
import PublicBoloPage from './pages/PublicBoloPage';

// Import layout components
import Header from './components/common/Header';
import Footer from './components/common/Footer';

const MarketingLayout: React.FC = () => (
  <>
    <Header />
    <main><Outlet /></main>
    <Footer />
  </>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/reports/:companySlug/:clientSlug/:token" element={<PublicReportPage />} />
          <Route path="/:companySlug/:clientSlug/:siteSlug/bolo/:token" element={<PublicBoloPage />} />
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/signup/success" element={<SignupSuccessPage />} />
            <Route path="/signup/:tier" element={<SignupPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
